module.exports = __webpack_public_path__ + "img/bn_safety.5e08e6f0.png";